<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box0">
      <!-- 轮播图 -->
      <el-carousel height="823px" indicator-position="none" arrow="never">
        <el-carousel-item>
          <img v-if="detailsList.pic" style="width: 100%; height: 100%"
               :src="detailsList.pic[0]" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 标题 -->
    <div class="title">
      <span>
        <!-- {{ detailsList.serveTitle }} -->
        {{ detailsList.name ? detailsList.name.substr(0, 1) : '' }} Inspector
      </span>
      <img src="../../assets/collection1.png" v-if="isCategory == 0"
           @click="getCategory" />
      <img src="../../assets/collection2.png" v-if="isCategory == 1"
           @click="getCategory" />
    </div>
    <div class="box">
      <!-- 简介 -->
      <div class="introduction">
        <div class="item item1">
          <p class="item-title">
            <span></span>
            <span v-if="detailsList.name">{{ detailsList.n1 }}***</span>
            <span v-if="detailsList.workStatus == 0"
                  style="color: #00fff0">Free</span>
            <span v-if="detailsList.workStatus == 1"
                  style="color: #10b962">Rest</span>
            <span v-if="detailsList.workStatus == 2" style="color: #ff511b">At
              work</span>
          </p>
          <div class="test" style="
              overflow: hidden;
              max-height: 244px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <p class="bg"></p>
            <ul>
              <li>
                <span>Price</span>
                <span>${{ parseInt(detailsList.price) }}</span>
              </li>
              <li>
                <span>Order number</span>
                <span>{{ detailsList.counts || 0 }}</span>
              </li>
              <li>
                <span>Service area</span>
                <span>{{ detailsList.workArea }}</span>
              </li>
              <li>
                <span>Areas of expertise</span>
                <span>{{ detailsList.beGoodAt }}</span>
              </li>
              <li>
                <span>Entire period of actual operation</span>
                <span>{{ detailsList.workYear }}Year</span>
              </li>
              <li>
                <span>Type</span>
                <span v-if="detailsList.serveType == 0">Pre-loading /
                  Discharging Survey</span>
                <span v-if="detailsList.serveType == 1">On/Off Hire Bunker
                  Survey/Bunker & Condition Survey</span>
                <span v-if="detailsList.serveType == 2">Bunkering Survey</span>
                <span v-if="detailsList.serveType == 3">Draft Survey</span>
                <span v-if="detailsList.serveType == 4">Insurance Adjust
                  Survey</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="item item2">
          <p class="item-title">
            <span></span>
            <span>Curriculum vitae</span>
            <span></span>
          </p>
          <p class="bg"></p>
          <div class="test" style="
              overflow: hidden;
              max-height: 244px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <li>{{ detailsList.resume }}</li>
          </div>
        </div>
        <div class="item item3">
          <p class="item-title">
            <span></span>
            <span>Working experience</span>
            <span></span>
          </p>
          <p class="bg"></p>
          <div class="test" style="
              overflow: hidden;
              max-height: 204px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <li>{{ detailsList.experience }}</li>
          </div>
        </div>
        <div class="item item4">
          <p class="item-title">
            <span>。。。。</span>
            <span>His score</span>
            <span style="color: #00fff0" v-if="detailsList.score">{{
                detailsList.score
              }}</span>
            <span style="color: #00fff0; font-size: 18px" v-else>暂无评价</span>
          </p>
          <p class="bg"></p>
          <div class="test">
            <div class="li">
              <div class="li-title" v-if="commentList.length == 0">
                暂无评价
              </div>
              <el-carousel height="206px" :autoplay="false"
                           indicator-position="none" arrow="always" v-else>
                <el-carousel-item v-for="(v, k) in commentList" :key="k">
                  <div class="li-item">
                    <div class="li-item-left">
                      <div class="div1"><img :src="v.userIcon" /></div>
                      <div class="div2">
                        <p class="up">
                          <span>{{ v.serveTitle }}</span>
                          <el-rate v-model="v.score" disabled
                                   :colors="['#00FFF0', '#00FFF0', '#00FFF0']"
                                   disabled-void-color="#33888E"></el-rate>
                        </p>
                        <p class="down">{{ v.content }}</p>
                      </div>
                    </div>
                    <div class="li-item-right">{{ v.createDate }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务案例 -->
      <div class="case" v-if="detailsList.atDocCaseList && detailsList.atDocCaseList.length > 0">
        <p class="case-title">Service case</p>
        <div class="case-content">
          <div class="case-item"
               v-for="(item, index) in detailsList.atDocCaseList" :key="index"
               @click="goCaseDetails(item)">
            <p class="case-item-top">{{ item.title }}</p>
            <div class="case-item-bottom">
              <div class="case-item-bottom-left">
                <img style="object-fit: cover;" v-if="item.icon"
                     :src="item.icon.split('|')[0]" />
              </div>
              <div class="case-item-bottom-right">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 他的日期 -->
      <!-- <div class="hisDate">
				<p class="hisDate-title">His date</p>
				<calendar
					v-if="detailsList"
					:gzList="detailsList.dateWorkArg"
					:xxList="detailsList.dateRestArg"
					:yxList="[]"
					@val="fnVal"
				></calendar>
			</div> -->
      <!-- 立即下单 -->
      <!-- <div class="ordernow" @click="goOrder">Order now</div> -->
      <!-- 你可能需要 -->
      <div class="need">
        <div class="nd-top">
          <div class="nd-top-title">You may also need</div>
        </div>
        <div class="nd-bottom" v-if="serveList && serveList.length > 0">
          <div class="nd-bottom-item" v-for="(item, index) in serveList"
               :key="index" @click="goDetails(item)">
            <div class="nd-bottom-item-top">{{ item.serveTitle }}</div>
            <div class="nd-bottom-item-bottom">
              <div class="nd-bottom-item-bottom-left">
                <img :src="item.pic" />
              </div>
              <div class="nd-bottom-item-bottom-right">
                <div class="nd-bottom-item-bottom-right-list">
                  <div class="nd-bottom-item-bottom-right-li">
                    Money：{{ item.price }}
                  </div>
                  <div class="nd-bottom-item-bottom-right-li">
                    Score：{{ item.score || 0 }}
                  </div>
                  <div class="nd-bottom-item-bottom-right-li">
                    Order quantity：{{ item.counts || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nd-bottom-empty" v-else>
          <p>No related services</p>
        </div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
import calendar from "../../components/calendar.vue";
export default {
  name: "detail",
  components: {
    navTop,
    navFooter,
    calendar,
  },
  data () {
    return {
      score: 4,
      id: "", //服务id
      detailsList: {}, //服务数据
      commentList: [], //评论列表
      count: "", //评论总条数
      serveList: [], //您可能还需要
      isCategory: "", //是否收藏
      calendarList: [], //已选日期
      type: "",
    };
  },
  created () {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.getDetail();
      this.getAppriselist();
      this.getIscategory();
    }
  },
  methods: {
    // 选择服务
    selectService (e) {
      this.service = e.target.value;
    },
    // 检验师详情
    getDetail () {
      let data = {
        serveId: this.id,
        // id: this.id,
      };
      this.$api.detail(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          if (res.data.pic) {
            res.data.pic = res.data.pic.split("|");
          } else {
            res.data.pic = [];
          }
          this.detailsList = res.data;
          this.getServe();
        }
      });
    },
    // 是否收藏
    getIscategory () {
      let data = {
        uid: sessionStorage.getItem("uid"),
        serveId: this.id,
      };
      this.$api.iscategory(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.isCategory = res.data.isCategory;
        }
      });
    },
    // 收藏、取消收藏
    getCategory () {
      let data = {
        uid: sessionStorage.getItem("uid"),
        serveId: this.id,
      };
      this.$api.category(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.getIscategory();
          this.$message({
            message: "success",
            type: "success",
            center: true,
            duration: 1000,
          });
        }
      });
    },
    // 评价列表
    getAppriselist () {
      let data = {
        serveId: this.id,
        nowPage: 1,
        pageCount: 10000,
      };
      this.$api.appriselist(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.commentList = res.data.list;
        }
      });
    },
    // 您可能还需要列表
    getServe () {
      let data = {
        type: 3,
        docId: this.detailsList.id,
        nowPage: 1,
        pageCount: 100000,
      };
      this.$api.serve(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.serveList = res.data.list;
        }
      });
    },
    // 您可能还需要跳转
    goDetails (item) {
      let data = {
        serveId: item.serveId,
      };
      this.$api.detail(data).then((res) => {
        console.log(res, "121212");
        if (res.result == 0) {
          this.id = item.serveId;
          console.log(res.data.pic);
          if (res.data.pic) {
            res.data.pic = res.data.pic.split("|");
          } else {
            res.data.pic = [];
          }

          this.detailsList = res.data;
          this.goOrder();
        }
      });
    },
    // 立即下单
    goOrder () {
      console.log("lijia");
      if (this.detailsList.serveType == 4) {
        let obj = {
          docId: this.detailsList.id,
          serveId: this.id,
          serveTitle: this.detailsList.serveTitle,
          name: this.detailsList.name,
          price: this.detailsList.price,
          serveType: this.detailsList.serveType,
          counts: this.detailsList.counts || 0,
          workYear: this.detailsList.workYear,
          workDate: JSON.stringify(this.calendarList),
          workArea: this.detailsList.workArea,
          dateWorkArg: JSON.stringify(this.detailsList.dateWorkArg || []),
          dateRestArg: JSON.stringify(this.detailsList.dateRestArg || []),
          servePic: this.detailsList.pic,
          appraiseStar: this.detailsList.score,
        };
        this.$router.push({
          path: "/insuranceOrder",
          query: { obj: JSON.stringify(obj) },
        });
      } else {
        let obj = {
          docId: this.detailsList.id,
          serveId: this.id,
          serveTitle: this.detailsList.serveTitle,
          name: this.detailsList.name,
          price: this.detailsList.price,
          serveType: this.detailsList.serveType,
          counts: this.detailsList.counts || 0,
          workYear: this.detailsList.workYear,
          workDate: JSON.stringify(this.calendarList),
          workArea: this.detailsList.workArea,
          dateWorkArg: JSON.stringify(this.detailsList.dateWorkArg || []),
          dateRestArg: JSON.stringify(this.detailsList.dateRestArg || []),
          servePic: this.detailsList.pic,
          appraiseStar: this.detailsList.score,
        };
        this.$router.push({
          path: "/placeOrder",
          query: { obj: JSON.stringify(obj) },
        });
      }
    },
    // 案例详情
    goCaseDetails (item) {
      let { href } = this.$router.resolve({
        path: "/caseDetails",
        query: { item: JSON.stringify(item) },
      });
      console.log(href);
      window.open(href, "_blank");
    },
    // 接受选择日期
    fnVal (val) {
      this.calendarList = val;
    },
  },
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.test::-webkit-scrollbar {
  width: 6px;
}

.test::-webkit-scrollbar-track {
  background-color: rgba(27, 168, 232, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

.test::-webkit-scrollbar-thumb {
  background-color: $blue-primary;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  box-shadow: 0 0 10px $blue-glow;
}

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box0 {
    padding-top: 30px;
    box-sizing: border-box;
    max-width: 1400px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    // 简介
    .introduction {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      justify-content: space-between;

      .item {
        width: calc(50% - 10px);
        min-width: 600px;
        border-radius: 21px;
        background: rgba(15, 43, 63, 0.8);
        backdrop-filter: blur(10px);
        border: 1px solid $blue-primary-rgba;
        box-shadow: 0 0 30px $blue-glow;
        padding: 20px 30px;
        box-sizing: border-box;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 5px 35px $blue-primary;
          border-color: $blue-primary;
        }

        .item-title {
          height: 60px;
          padding: 10px 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid $blue-primary-rgba;

          span:nth-child(1) {
            display: inline-block;
            width: 60px;
          }

          span:nth-child(2) {
            font-size: 24px;
            color: $blue-primary;
            line-height: 1em;
            text-shadow: $text-glow;
          }

          span:nth-child(3) {
            display: inline-block;
            width: 80px;
            font-size: 18px;
            color: #ff6b4a;
            line-height: 1em;
            text-align: center;
          }
        }
      }

      .item1 {
        ul {
          padding: 15px 20px;
          box-sizing: border-box;

          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            padding: 5px 0;
            border-bottom: 1px dashed $blue-primary-rgba;

            span:nth-child(1) {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #c0e4ff;
            }

            span:nth-child(2) {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: $blue-primary;
            }
          }
        }
      }

      .item2, .item3 {
        li {
          padding: 15px 20px;
          box-sizing: border-box;
          font-size: 18px;
          color: #c0e4ff;
          line-height: 1.6;
        }
      }

      .item4 {
        .li {
          padding: 15px 0;
          box-sizing: border-box;

          .li-title {
            width: 100%;
            font-size: 20px;
            color: #c0e4ff;
            text-align: center;
            padding: 40px 0;
          }

          ::v-deep .el-carousel__arrow {
            background: rgba(27, 168, 232, 0.3);
            width: 30px;
            height: 30px;
            border-radius: 50%;

            i {
              color: $blue-primary;
              font-size: 20px;
            }

            &:hover {
              background: rgba(27, 168, 232, 0.5);
            }
          }

          ::v-deep .el-carousel__arrow--left {
            left: 0;
          }

          ::v-deep .el-carousel__arrow--right {
            right: 0;
          }

          .li-item {
            width: 100%;
            height: 100%;
            margin-bottom: 10px;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .li-item-left {
              display: flex;
              align-items: center;
              flex: 1;

              .div1 {
                img {
                  width: 60px;
                  height: 60px;
                  display: block;
                  border-radius: 50%;
                  border: 2px solid $blue-primary;
                  box-shadow: 0 0 15px $blue-glow;
                }
              }

              .div2 {
                margin-left: 15px;
                flex: 1;

                .up {
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 10px;

                  span {
                    font-size: 16px;
                    font-weight: bold;
                    color: $blue-primary;
                  }

                  ::v-deep .el-rate__icon {
                    margin-right: 2px;
                    font-size: 16px;
                  }
                }

                .down {
                  width: 100%;
                  margin-top: 5px;
                  font-size: 14px;
                  font-weight: bold;
                  color: #c0e4ff;
                  line-height: 1.5;
                }
              }
            }

            .li-item-right {
              font-size: 12px;
              color: $blue-primary;
              white-space: nowrap;
              margin-left: 10px;
            }
          }
        }
      }
    }

    // 服务案例
    .case {
      width: 100%;
      border-radius: 45px;
      margin-top: 50px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      box-shadow: 0 0 40px $blue-glow;
      padding: 30px 40px;
      box-sizing: border-box;

      .case-title {
        padding-top: 10px;
        box-sizing: border-box;
        line-height: 1em;
        font-size: 48px;
        color: $blue-primary;
        text-align: center;
        text-shadow: $text-glow;
        margin-bottom: 30px;
      }

      .case-content {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        gap: 30px;

        .case-item {
          width: calc(33.333% - 20px);
          min-width: 300px;
          margin-right: 0;
          margin-bottom: 0;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-5px);

            .case-item-bottom-right {
              box-shadow: 0 5px 25px $blue-primary;
            }
          }

          .case-item-top {
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #ffffff;
            line-height: 1.2em;
            margin-bottom: 8px;
            text-align: right;
            padding-right: 30px;
            padding-left: 150px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
          }

          .case-item-bottom {
            display: flex;
            align-items: flex-start;

            .case-item-bottom-left {
              width: 180px;
              height: 110px;
              background: linear-gradient(135deg, $blue-primary 0%, $blue-secondary 100%);
              border-radius: 10px;
              padding: 10px;
              box-sizing: border-box;
              box-shadow: 0 0 20px $blue-glow;

              img {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 5px;
                object-fit: cover;
              }
            }

            .case-item-bottom-right {
              width: 250px;
              min-height: 120px;
              background: rgba(27, 168, 232, 0.15);
              border: 1px solid $blue-primary-rgba;
              border-radius: 10px;
              margin-left: -30px;
              color: #ffffff;
              padding: 20px 15px 15px 40px;
              box-sizing: border-box;
              line-height: 1.5;
              font-size: 14px;
              box-shadow: 0 0 20px $blue-glow inset;
              transition: all 0.3s ease;
            }
          }
        }
      }
    }

    // 他的日期
    .hisDate {
      width: 100%;
      border-radius: 45px;
      margin-top: 50px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      box-shadow: 0 0 40px $blue-glow;
      padding: 50px 60px;
      box-sizing: border-box;

      .hisDate-title {
        line-height: 1em;
        font-size: 48px;
        color: $blue-primary;
        text-align: center;
        text-shadow: $text-glow;
        margin-bottom: 50px;
      }
    }

    // 立即下单
    .ordernow {
      width: 500px;
      height: 80px;
      background: linear-gradient(
              90deg,
              rgba(27, 168, 232, 0.8) 0%,
              rgba(27, 168, 232, 0.6) 100%
      );
      margin: 50px auto;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
      border-radius: 40px;
      border: 1px solid $blue-primary;
      box-shadow: 0 0 30px $blue-glow;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 5px 40px $blue-primary;
        background: linear-gradient(
                90deg,
                rgba(27, 168, 232, 0.9) 0%,
                rgba(27, 168, 232, 0.7) 100%
        );
      }
    }

    // 你可能需要 - 修复框大小问题，将左侧图片也框起来
    .need {
      width: 100%;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      border-radius: 45px;
      box-shadow: 0 0 40px $blue-glow;
      padding: 30px 30px 50px;
      box-sizing: border-box;
      margin: 50px 0 80px;

      .nd-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;

        .nd-top-title {
          width: 280px;
          height: 45px;
          background: linear-gradient(90deg, $blue-primary 0%, $blue-secondary 100%);
          border-radius: 0 25px 25px 0;
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
          text-align: center;
          padding-left: 30px;
          line-height: 45px;
          box-sizing: border-box;
          text-shadow: 0 0 10px rgba(255,255,255,0.5);
          box-shadow: 0 0 20px $blue-glow;
        }
      }

      .nd-bottom {
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        gap: 25px;
        justify-content: flex-start;

        .nd-bottom-item {
          width: calc(25% - 19px);
          min-width: 300px;
          margin-right: 0;
          margin-bottom: 0;
          cursor: pointer;
          transition: all 0.3s ease;
          background: rgba(27, 168, 232, 0.1);
          border: 1px solid $blue-primary-rgba;
          border-radius: 16px;
          padding: 15px 15px 15px 15px;
          box-shadow: 0 0 20px $blue-glow;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 30px $blue-primary;
            border-color: $blue-primary;
          }

          .nd-bottom-item-top {
            width: 100%;
            text-align: left;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            padding-left: 0;
            padding-right: 5px;
            padding-bottom: 10px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 10px;
            border-bottom: 1px dashed $blue-primary-rgba;
            text-shadow: 0 0 5px $blue-glow;
          }

          .nd-bottom-item-bottom {
            display: flex;
            align-items: center;
            gap: 15px;

            .nd-bottom-item-bottom-left {
              width: 100px;
              height: 100px;
              background: linear-gradient(135deg, $blue-primary 0%, $blue-secondary 100%);
              border-radius: 10px;
              padding: 8px;
              box-sizing: border-box;
              box-shadow: 0 0 15px $blue-glow;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 5px;
                object-fit: cover;
              }
            }

            .nd-bottom-item-bottom-right {
              flex: 1;
              min-width: 0;

              .nd-bottom-item-bottom-right-list {
                width: 100%;
                background: rgba(27, 168, 232, 0.1);
                border: 1px solid $blue-primary-rgba;
                border-radius: 8px;
                padding: 12px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 8px;
                box-shadow: 0 0 15px $blue-glow inset;
                transition: all 0.3s ease;

                .nd-bottom-item-bottom-right-li {
                  color: #c0e4ff;
                  line-height: 1.4;
                  font-size: 14px;
                  width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;

                  &:first-child {
                    color: $blue-primary;
                    font-weight: bold;
                  }
                }
              }
            }
          }
        }
      }

      .nd-bottom-empty {
        width: 100%;
        padding: 50px 0;
        text-align: center;

        p {
          color: #c0e4ff;
          font-size: 18px;
          text-shadow: $text-glow;
        }
      }
    }
  }

  .title {
    margin-top: 30px;
    width: 100%;
    height: 100px;
    background: rgba(15, 43, 63, 0.9);
    backdrop-filter: blur(10px);
    border-top: 1px solid $blue-primary;
    border-bottom: 1px solid $blue-primary;
    box-shadow: 0 0 30px $blue-glow;
    position: relative;
    z-index: 2;

    span {
      margin: 0 auto;
      max-width: 1400px;
      height: 100px;
      display: block;
      text-align: center;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: $blue-primary;
      line-height: 100px;
      padding-right: 80px;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-shadow: $text-glow;
    }

    img {
      width: 40px;
      height: 35px;
      display: block;
      position: absolute;
      top: 32px;
      right: calc(50% - 650px);
      cursor: pointer;
      transition: all 0.3s ease;
      filter: drop-shadow(0 0 8px $blue-glow);

      &:hover {
        transform: scale(1.1);
        filter: drop-shadow(0 0 15px $blue-primary);
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1400px) {
  .pages {
    .title {
      img {
        right: 100px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding-left: 15px;
      padding-right: 15px;

      .introduction {
        .item {
          min-width: 100%;
          width: 100%;

          .item-title {
            span:nth-child(2) {
              font-size: 20px;
            }
          }
        }

        .item1, .item2, .item3, .item4 {
          ul li span, li {
            font-size: 16px;
          }
        }
      }

      .case {
        padding: 20px;

        .case-title {
          font-size: 36px;
        }

        .case-content {
          .case-item {
            width: calc(50% - 15px);

            .case-item-bottom {
              .case-item-bottom-left {
                width: 150px;
                height: 90px;
              }

              .case-item-bottom-right {
                width: 200px;
                font-size: 13px;
                padding-left: 30px;
              }
            }
          }
        }
      }

      .need {
        .nd-bottom {
          .nd-bottom-item {
            width: calc(50% - 13px);
            min-width: 280px;
          }
        }
      }
    }

    .title {
      span {
        font-size: 28px;
      }

      img {
        width: 35px;
        height: 30px;
        top: 35px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .case {
        .case-content {
          .case-item {
            width: 100%;
          }
        }
      }

      .need {
        .nd-bottom {
          .nd-bottom-item {
            width: 100%;
          }
        }
      }
    }

    .title {
      height: 80px;

      span {
        font-size: 22px;
        line-height: 80px;
      }

      img {
        width: 30px;
        height: 25px;
        top: 27px;
        right: 30px;
      }
    }
  }
}
</style>